export const paymentMethodsQuery = `
query PaymentMethods($userId: String!) {
  paymentMethods(userId: $userId) {
    ... on CardPaymentMethod {
      id
      type
      cardExpiry
      cardHolder
      cardType
      maskedCardNumber
      token
    }
    ... on DebitPaymentMethod {
      id
      type
      accountLast4
      accountName
      accountBsb
      accountNumber
    }
  }
}
`;